import { useEffect } from 'react';
import { useQueryParams } from 'src/shared/hooks/useQueryParams';
export function useScrollToHighlightedModule({ moduleId, onHighlight }) {
    const { getQueryParam, removeQueryParam } = useQueryParams('moduleId');
    const isHighlightedModuleId = getQueryParam() === moduleId;
    useEffect(function scrollToCardIfHighlighted() {
        if (isHighlightedModuleId) {
            onHighlight().then(removeQueryParam);
        }
    }, [isHighlightedModuleId, onHighlight, removeQueryParam]);
}
